
export default function TSeriesNavService(gettext) {

    'ngInject';
    
    var module = {
        "id": "tseries",
        "name": gettext("T-Series"),
        "sref": "tseries",
        "icon": "ti-signal",
        "priority": 30,
    };

    this.getModule = function () {
        return module;
    };

}
